module.exports = __webpack_public_path__ + "images/map-style-2-7b91d8935360e3a77c6188e18613c0ff.jpg";